import { object, string } from 'yup';
import { AddUserModalProps } from 'enums/AddUserModalProps';
interface CategoryOptions {
  value: string;
  label: string;
}
export const options: CategoryOptions[] = [
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'manager',
    label: 'Manager',
  },
  {
    value: 'employee',
    label: 'Employee',
  },
  {
    value: 'superAdmin',
    label: 'Super Admin',
  },
];
const phoneRegExp = /^\d{10,15}$/;
export const validationSchema = object({
  name: string().required(AddUserModalProps.ERROR_MESSAGE),
  role: string().required(AddUserModalProps.ERROR_MESSAGE),
  email: string().email().required(AddUserModalProps.ERROR_MESSAGE),
  phone: string().matches(
    phoneRegExp,
    'Phone number must be between 10 and 15 digits and can only contain numbers'
  ),
  position: string().required(AddUserModalProps.ERROR_MESSAGE),
});
